import Loadercomp from '../Loadercomp';
import FormComponent from './Form';

const Layoutcreatepage = ({
  title,
  fields,
  validationSchema,
  initialValues,
  loading,
  feedbackMessage,
  onSubmit,
  buttonText,
  secondbtntext,
  onCancel,
  onChange,
  feedbackRef,
}) => {
  return (
    <div className="relative bg-white shadow-md rounded-lg">
      {loading && (
        <div className="absolute inset-0 bg-white bg-opacity-70 flex items-center justify-center z-50">
          <Loadercomp size={100} />
        </div>
      )}

      <div className="pl-8 pt-5">
        <h2 className="font-inter text-2xl text-[#333843] font-semibold">{title}</h2>
      </div>

      <div className="container-fluid pb-4 pt-3 px-4 bg-white">
        <FormComponent
          fields={fields}
          validationSchema={validationSchema}
          initialValues={initialValues}
          onSubmit={onSubmit}
          secondbtn={secondbtntext}
          buttonText={buttonText}
          onCancel={onCancel}
          onChange={onChange}
        />

        {feedbackMessage?.message && (
          <div
            ref={feedbackRef}
            className={`mt-3 mx-3 rounded-lg px-4 py-3 text-lg font-medium ${
              feedbackMessage.type === 'success'
                ? 'bg-green-100 text-green-700 border border-green-300'
                : 'bg-red-100 text-red-700 border border-red-300'
            }`}
            role="alert"
          >
            {feedbackMessage.message}
          </div>
        )}
      </div>
    </div>
  );
};

export default Layoutcreatepage;



